// STRICT session storage — no localStorage fallback
// Browser close = forced logout

const TOKEN_KEYS = ['aegis_token', 'master_token'];

export function setToken(key, value) {
  sessionStorage.setItem(key, value);
  // CRITICAL: also clear any stale localStorage token
  localStorage.removeItem(key);
  localStorage.setItem('__session_sync__', Date.now().toString());
  localStorage.removeItem('__session_sync__');
}

export function getToken(key) {
  // STRICT: only sessionStorage. No localStorage fallback.
  return sessionStorage.getItem(key);
}

export function clearToken(key) {
  sessionStorage.removeItem(key);
  localStorage.removeItem(key);
}

export function clearAllTokens() {
  TOKEN_KEYS.forEach(k => {
    sessionStorage.removeItem(k);
    localStorage.removeItem(k);
  });
  localStorage.setItem('__logout_sync__', Date.now().toString());
  localStorage.removeItem('__logout_sync__');
}

export function onTokenChange(callback) {
  const handler = (e) => {
    if (e.key === '__logout_sync__' || e.key === '__session_sync__') callback();
  };
  window.addEventListener('storage', handler);
  return () => window.removeEventListener('storage', handler);
}

// Run on app boot — clean any leftover localStorage tokens from old versions
export function migrateOldTokens() {
  let cleaned = 0;
  TOKEN_KEYS.forEach(k => {
    if (localStorage.getItem(k)) {
      localStorage.removeItem(k);
      cleaned++;
    }
  });
  return cleaned;
}
